import { render } from "./post-training-applications.vue?vue&type=template&id=2edc06c6&scoped=true"
import script from "./post-training-applications.vue?vue&type=script&lang=js"
export * from "./post-training-applications.vue?vue&type=script&lang=js"

import "./post-training-applications.vue?vue&type=style&index=0&id=2edc06c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2edc06c6"

export default script